import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';

//msal imports
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from "./authentication/authConfig"

import registerServiceWorker, { unregister } from './registerServiceWorker';

import { ModuleRegistry, AllCommunityModule } from "ag-grid-community";
import { AllEnterpriseModule, LicenseManager } from "ag-grid-enterprise";

ModuleRegistry.registerModules([
    AllCommunityModule,
    AllEnterpriseModule
]);

LicenseManager.setLicenseKey(process.env.REACT_APP_AG_GRID_LICENSE);

const rootElement = document.getElementById('root');

ReactDOM.render(
    <React.StrictMode>
        <MsalProvider instance={msalInstance}>
            <Router>
                <App />
            </Router>
        </MsalProvider>
    </React.StrictMode>,
    rootElement);

registerServiceWorker();

